<template>
  <label class="color" :style="`background-color: ${color}; --color: ${color}`">
    <span class="sr-only">{{ color }}</span>
    <input
      type="checkbox"
      :value="color"
      name="colors[]"
      :disabled="disabled"
      v-model="colorFilter"
      @click="toggleColor"
    />
  </label>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { colorFilter } from '../utils/filter.ts';
import { toggle } from '../utils/utils.ts';

export default defineComponent({
  name: 'FilterVocabularyComponent',

  props: {
    color: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const toggleColor = (): void => {
      colorFilter.value = toggle(colorFilter.value, props.color);
    };
    return {
      toggleColor,
      colorFilter,
    };
  },
});
</script>
